import { IMenu, PopupPage } from '@/utils/index.model';

interface IMenuState {
  menu: IMenu;
}

const MENU_DATA: IMenu = {
  isPopupOpen: false,
  activePopupPage: PopupPage.main,
  isJackpotPopupOpen: false,
  isErrorPopupOpen: false,
  errorHeading: '',
  errorMsg: '',
};

export const state = () => ({ menu: { ...MENU_DATA } });

export const mutations = {
  UPDATE_MENU(stateData: IMenuState, menu: Partial<IMenu>): void {
    stateData.menu = { ...stateData.menu, ...menu };
  },
  RESET_MENU(stateData: IMenuState) {
    stateData.menu = { ...MENU_DATA };
  },
};

export const actions = {
  updateMenu(context: any, menu: Partial<IMenu>): void {
    if (!menu.activePopupPage || ![PopupPage.betDetail, PopupPage.history].includes(menu.activePopupPage)) {
      context.dispatch(
        'general/updateGeneral',
        {
          constrols: {
            historySelection: '',
          },
        },
        { root: true }
      );
    }
    context.commit('UPDATE_MENU', menu);
  },
  resetMenu(context: any): void {
    context.commit('RESET_MENU');
  },
};

export const getters = {
  isPopupOpen: (stateData: any): boolean => {
    return stateData.menu.isPopupOpen;
  },
  isJackpotPopupOpen: (stateData: any): boolean => {
    return stateData.menu.isJackpotPopupOpen;
  },
  activePopupPage: (stateData: any): string => {
    return stateData.menu.activePopupPage;
  },
  isErrorPopupOpen: (stateData: any): boolean => {
    return stateData.menu.isErrorPopupOpen;
  },
  errorMsg: (stateData: any): string => {
    return stateData.menu.errorMsg;
  },
  errorHeading: (stateData: any): string => {
    return stateData.menu.errorHeading;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
